import React from 'react'
import { useOn, useState } from 'hooks'
import { connect } from 'react-redux'

import { T } from 'components/Translations'
import Avatar, { ImageUpload } from 'components/Avatar'
import Icon from 'components/Icon'
import Modal from '../Modal'
import * as modalTypes from '../modalTypes'
import StyledGalleryModal, { StyledGalleryItem } from './StyledGalleryModal'
import { openModal, setDefaultImage, deleteImage } from 'store/actions'
import { galleryModalType } from 'common/types'

const useIndex = (initialIndex, length) => {
  const [index, setIndex] = useState(initialIndex)

  const fix = index => (index + length) % length

  return {
    index,
    setIndex,
    next: () => setIndex(index => fix(index + 1)),
    prev: () => setIndex(index => fix(index - 1)),
  }
}

const GalleryModal = ({ initialIndex, user, mine, openModal, setDefaultImage, deleteImage }) => {
  const images = user.media || []
  const { index, setIndex, next, prev } = useIndex(initialIndex, images.length)
  const image = images[index] || {}

  useOn('keydown', e => {
    e.key == 'ArrowLeft' && prev()
    e.key == 'ArrowRight' && next()
  })

  return (
    <Modal transparentBackground modalId={modalTypes.GALLERY_MODAL}>
      <StyledGalleryModal>
        <div className="main">
          <Avatar className="main-image" basic user={user} mediaIndex={index} />

          {mine && (
            <div className="top-right-controls">
              <div className="item">
                <Icon family="fas" name="trash" onClick={() => deleteImage(user.nickname, image.id)} />
              </div>
            </div>
          )}

          {images.length > 1 && (
            <div className="arrows">
              <Icon name="angle-left" />
              <Icon name="angle-right" />
            </div>
          )}

          {mine && (
            <div className="set-as-default" onClick={() => setDefaultImage(user.nickname, image.id)}>
              <Icon name={image.isDefault ? 'check' : 'user'} />
              <T as="span" label={image.isDefault ? 'default' : 'actions/setDefault|basicHTML'} />
            </div>
          )}

          <div className="image-amount">
            <Icon name="camera" />
            {index + 1} / {images.length}
          </div>
        </div>

        <div className="image-list">
          {images.length > 1 &&
            images.map((_, i) => (
              <StyledGalleryItem key={i} active={index === i} onClick={() => setIndex(i)}>
                <div className="active-indicator">
                  <Avatar user={user} mediaIndex={i} />
                </div>
              </StyledGalleryItem>
            ))}

          {mine && (
            <StyledGalleryItem className="upload">
              <ImageUpload onClick={() => openModal(modalTypes.UPLOAD_PHOTO_MODAL)} />
            </StyledGalleryItem>
          )}
        </div>
      </StyledGalleryModal>
    </Modal>
  )
}

GalleryModal.propTypes = galleryModalType

GalleryModal.defaultProps = {
  mine: false,
}

const mapStateToProps = ({ myProfile }, { data: { user, index = 0 } }) => ({
  mine: user.id == myProfile.id,
  user: user.id == myProfile.id ? myProfile : user,
  initialIndex: index,
})

export default connect(mapStateToProps, { setDefaultImage, deleteImage, openModal })(GalleryModal)
